export default "__VITE_ASSET__CnbzzN5h__"